<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         src="@/assets/theme/light/status/01dailyActive/01back.svg">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('sleepShort.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="short-box">
                <div class="short-top">
                    <img class="short-icon" src="@/assets/theme/light/status/06sleep/06short.png">
                    <span class="short-title">{{ $t('sleepShort.shortTitle') }}</span>
                </div>
                <div class="short-info" v-for="(item, index) in sleepArr">
                    <div class="line" v-if="index != 0"></div>
                    <div class="total-value"><span v-if="item.hour">{{ item.hour }}{{ $t('sleep.hour') }}</span><span
                        v-if="item.minute"><span>{{ item.minute }}</span>{{ $t('sleep.minute') }}</span></div>
                    <div class="short-info-time">{{ item.start }} - {{ item.end }}</div>
                </div>
            </div>
            <div class="desc-box">
                <div class="desc-title">{{ $t('sleepShort.shortTitle') }}</div>
                <div class="desc-info">{{ $t('sleepShort.shortDesc') }}</div>
                <div class="desc-title">{{ $t('sleepShort.suggest') }}</div>
                <div class="desc-info">{{ $t('sleepShort.suggest0') }}</div>
                <div class="desc-info">{{ $t('sleepShort.suggest1') }}</div>
                <div class="desc-info last-desc">{{ $t('sleepShort.suggest2') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {calculateDuration, GetMinute} from "../../utils/dateUtils";

export default {
    name: '06sleepShort',
    data() {
        return {
            sleepArr: []
        }
    },
    mounted() {
        if (this.$route.query.shortSleep) {
            let shortArr = JSON.parse(this.$route.query.shortSleep);
            shortArr.forEach((item, index) => {
                const duration = calculateDuration(item.startTs, item.endTs);
                let hour = Math.floor(duration / 60);
                let minute = GetMinute(duration / 60);
                this.sleepArr.push({
                    start: item.startTs,
                    end: item.endTs.substring(11),
                    hour: hour,
                    minute: minute
                });
            });
        }
    },
    methods: {
        back() {
            this.$router.back();
        }
    }
}
</script>

<style scoped>
.content {
    margin-top: 88px;
}

.desc-box {
    width: 345px;
    margin: 10px auto;
    background-color: var(--bg-color-2);
    border-radius: 13px;
}

.desc-title {
    color: var(--text-color-1);
    font-size: 17px;
    padding: 20px 0 12px 20px;
}

.desc-info {
    color: var(--text-color-2);
    font-size: 13px;
    line-height: 23px;
    margin: 0 8px 0px 20px;
}

.last-desc {
    padding-bottom: 15px;
}

.short-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 0 auto;
}

.short-top {
    position: relative;
    height: 40px;
}

.short-icon {
    width: 20px;
    position: absolute;
    left: 14px;
    top: 12px;
}

.short-title {
    font-size: 13px;
    color: var(--text-color-2);
    position: absolute;
    left: 34px;
    top: 13px;
}

.total-value {
    font-size: 17px;
    color: var(--text-color-1);
    font-family: PP;
    margin-bottom: 4px;
}

.short-info-time {
    font-size: 13px;
    color: var(--text-color-2);
}

.short-info {
    width: 297px;
    margin-left: 34px;
    padding-bottom: 16px;
}

.line {
    border: 1px solid var(--line-color-3);
    margin-bottom: 16px;
}
</style>


// WEBPACK FOOTER //
// src/views/status/06sleepShort.vue